import React from 'react';
import './DispatchBoard.scss';
import { CardBody, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import { faHardHat, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import { ConfirmationStatus } from '../cancelConfirmation/CancelConfirmation';
import { LocalizationKeys as l } from '../Common';
import { DraggableResourceTypes } from './Dispatch';
import { SmallButton } from '../common/forms/FormElements';

export default class StaffJobAssignment extends React.Component {
    getStatusName = () => this.props.group.assignment ? this.props.group.assignment.confirmationStatusName
        .replace(' ', '')
        .toLowerCase() : '';
    
    // support keyboard “click”
    handleKeyDown = (e, dropId, ids) => {
        const { onSlotSelect } = this.props;
        if (e.key === 'Enter' || e.key === ' ') {
            onSlotSelect('staff', ids, dropId);
        }
    };

    render() {
        const {
            job, day, group, jobIndex, assignmentIndex, strings, isDropZoneValid, dragging, dispatchLocation, onSlotSelect, pulsingSlotId
        } = {
            ...this.props,
        };
        const crewLead = strings[l.crewLead];
        const dayInt = day.getDay();
        const dropId = `staff_${jobIndex}_${dayInt}_${assignmentIndex}`;
        const hasAssignment = !!group.assignment;
        const canDrop = isDropZoneValid(DraggableResourceTypes.Staff, group.assignableGroups) && !hasAssignment;
        const ids = group.assignableGroups.map(g => g.id);
  
        return (
            <div key={dropId} className="jobAssignment">
                <Droppable 
                    key={dropId}
                    droppableId={dropId} 
                    isDropDisabled={!canDrop}
                    style={{ transform: 'none' }}
                >
                    {(provided, snapshot) => (
                        <div
                            className="assignment-placeholder-row"
                            style={{ height: '50px !important' }}
                        >
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className={cls(
                                    'jobAssignmentDropTarget',
                                    this.getStatusName(),
                                    {
                                        dragging: snapshot.isDraggingOver,
                                        show: !hasAssignment || snapshot.isDraggingOver,
                                        invalidDropZone: !canDrop && dragging,
                                        occupied: hasAssignment,
                                        pulse: !hasAssignment && dropId === pulsingSlotId
                                    }
                                )}
                                role={!hasAssignment ? 'button' : undefined}
                                tabIndex={!hasAssignment ? 0 : undefined}
                                onClick={() => {
                                    if (!hasAssignment) {
                                        onSlotSelect('staff', ids, dropId);
                                    }
                                }}
                                onKeyDown={e => this.handleKeyDown(e, dropId, ids)}
                            >
                                {hasAssignment ? (
                                    <div className="card staffCard compact">
                                        <CardBody>
                                            <CardTitle className="text-left d-flex flex-row justify-content-between align-items-center">
                                                <span className="d-flex flex-row flex-fill justify-content-between align-items-center">
                                                    <span>
                                                        {`${group.name}`}

                                                        {dispatchLocation && dispatchLocation.id !== job.dispatchLocationId && (
                                                            <span className="d-block">Dispatched from {dispatchLocation.name}</span>
                                                        )}
                                                    </span>
                                                    <div className="d-flex flex-column">
                                                        <div className="d-flex flex-row justify-content-end align-items-center">
                                                            <SmallButton
                                                                color="link"
                                                                title={
                                                                    group.isCrewLead
                                                                        ? crewLead
                                                                        : `Mark this employee as the ${crewLead}`
                                                                }
                                                                className="p-0 mr-1"
                                                                onClick={() => {
                                                                    if (
                                                                        job
                                                                            .assignments[
                                                                                dayInt
                                                                            ]
                                                                            .canEdit
                                                                    ) {
                                                                        this.props.setCrewLead(
                                                                            group.jobAssignmentId,
                                                                            job.id,
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faHardHat}
                                                                    className={cls(
                                                                        'crewLeadBadge',
                                                                        {
                                                                            isCrewLead:
                                                                        !!group.isCrewLead,
                                                                        },
                                                                    )}
                                                                />
                                                            </SmallButton>
                                                            <span className="text-overflow-ellipsis mr-2">
                                                                {group.assignment.name}
                                                            </span>
                                                        </div>
                                                        <span
                                                            className={`text-right assignment-status-label mr-2 ${group.assignment.confirmationStatusName
                                                                .replace(
                                                                    ' ',
                                                                    '',
                                                                )
                                                                .toLowerCase()}`}
                                                        >
                                                            {group.assignment.confirmationStatusName}
                                                        </span>
                                                    </div>
                                                </span>
                                                {
                                                    // job.canEdit is backed by whether or not the crew has submitted a timesheet.
                                                    // if we have a timesheet for this crew for this day, we cannot remove the assignment.
                                                    group.assignment
                                                        .confirmationStatusId
                                                        != ConfirmationStatus.CancelPending
                                                        && !!job.assignments[
                                                            dayInt
                                                        ].canEdit && (
                                                        <SmallButton
                                                            color="link"
                                                            title="Remove this personnel"
                                                            className="p-0"
                                                            onClick={() => this.props.onRemoveAssignment(
                                                                job,
                                                                group,
                                                                dayInt,
                                                            )}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faMinusCircle}
                                                                className="text-danger"
                                                            />
                                                        </SmallButton>
                                                    )
                                                }
                                            </CardTitle>
                                        </CardBody>
                                    </div>
                                ) : (
                                    <div className="dropPlaceholderWrapper">
                                        <label className="dropPlaceholder mr-1">
                                            {group.name}
                                        </label>
                                        {group.assignableGroups.map((g) => (
                                            <span
                                                title={g.groupName}
                                                key={g.id}
                                                className="badge badge-lg badge-secondary mr-1"
                                            >
                                                {g.groupName
                                                    .charAt(0)
                                                    .toUpperCase()}
                                            </span>
                                        ))}
                                    </div>
                                )}

                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
